export enum FilterKind {
  REGION = 'REGION',
  INTERESTS = 'INTERESTS',
  FLIGHT = 'FLIGHT',
  TIME_FRAME = 'TIME_FRAME',
  BUDGET = 'BUDGET',
  ACCOMMODATION = 'ACCOMMODATION',
  TRAVELERS = 'TRAVELERS',
}
